import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';
import { DTP_DEFAULT_FORMAT, PRODUCE_STRING } from './constants';
import { finalValuesCases } from './functions';

/**
 *
 * props:
 *  produces: permite especificar el tipo de dato que generará el componente
 *  al momento de establecer un valor. Los valore posibles son string o date
 *
 *  format: permite especificar el formato con que se mostrarán las fechas
 *  por defecto se utiliza YYYY-MM-DD HH:mm:ss
 */

// TODO: corregir alerta de moment al momento de borrar el valor del input desde el teclado

function DateTimePickerBase({
  produces,
  format,
  label,
  field,
  disablePast,
  maxDate,
  form: {
    setFieldValue, errors, touched, setFieldTouched, ...form
  },
  field: { name, value },
  ampm,
  minDate,
  initialFocusedDate,
  onChangeProps,
  ...rest
}) {
  const styles = makeStyles({
    textHelp: {
    },
  });
  const classes = styles();
  const hasError = touched[name] && Boolean(errors[name]);
  return (
    <KeyboardDateTimePicker
      fullWidth
      autoComplete="off"
      inputVariant="outlined"
      margin="dense"
      name={name}
      clearable
      className={classes.textHelp}
      autoOk
      error={hasError}
      helperText={hasError && errors[name]}
      label={label}
      format={format}
      clearLabel="Limpiar"
      okLabel="Aceptar"
      cancelLabel="Cancelar"
      todayLabel="Hoy"
      value={value || null}
      disablePast={disablePast}
      maxDate={maxDate}
      minDate={minDate}
      initialFocusedDate={initialFocusedDate}
      animateYearScrolling={false}
      ampm={ampm}
      onChange={(valueToSet) => {
        let finalValue = valueToSet;
        if (valueToSet) {
          finalValue = finalValuesCases(finalValue, produces, format);
        }
        setFieldTouched(name, true);
        setFieldValue(name, finalValue);
        if (onChangeProps) {
          onChangeProps(finalValue, form);
        }
      }}
      {...rest}
    />
  );
}

DateTimePickerBase.defaultProps = {
  produces: PRODUCE_STRING,
  label: '',
  format: DTP_DEFAULT_FORMAT,
  disablePast: true,
  maxDate: '2100-01-01',
  minDate: '1900-01-01',
  ampm: false,
  initialFocusedDate: new Date().toISOString(),
};

DateTimePickerBase.propTypes = {
  produces: PropTypes.string,
  disablePast: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ]),
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
  initialFocusedDate: PropTypes.string,
  format: PropTypes.string,
  form: PropTypes.shape({
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    setFieldTouched: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  // Prop encargado de mostrar el formato de fecha
  ampm: PropTypes.bool,
  onChangeProps: PropTypes.func,
};

export default DateTimePickerBase;
